(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Same tab-switching behavior as rizon-search.liquid's own copy (guarded
  // define, since both this section and the search page's section load
  // their own javascript block and would otherwise collide there).
  class RizonSearchTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-search-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-search-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.searchTab));
      });
    }
    select(name) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.searchTab === name;
        tab.classList.toggle('rizon-tab-search--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.searchPanel !== name;
      });
    }
  }
  if (!customElements.get('rizon-search-tabs')) {
    customElements.define('rizon-search-tabs', RizonSearchTabs);
  }

  class RizonSearchModalLive extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.input = this.querySelector('.rizon-search-field-large__input');
      this.resultsEl = this.querySelector('[data-search-live-results]');
      this.initialResultsHTML = this.resultsEl.innerHTML;
      this.abortController = null;
      this.debounceTimer = null;

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(() => this.update(this.input.value.trim()), 300);
      });
    }

    async update(term) {
      if (this.abortController) this.abortController.abort();

      if (!term) {
        this.resultsEl.innerHTML = this.initialResultsHTML;
        return;
      }

      this.abortController = new AbortController();
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=${this.sectionId}&resources[type]=product,collection,page&resources[limit]=10&resources[limit_scope]=each`;

      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) return;
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newResults = doc.querySelector('[data-search-live-results]');
        if (newResults) this.resultsEl.innerHTML = newResults.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    }
  }
  if (!customElements.get('rizon-search-modal-live')) {
    customElements.define('rizon-search-modal-live', RizonSearchModalLive);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizon-404"] && !Shopify.designMode) return;
  try {
    
  class RizonSearchTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-search-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-search-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.searchTab));
      });
    }
    select(name) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.searchTab === name;
        tab.classList.toggle('rizon-tab-search--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.searchPanel !== name;
      });
    }
  }
  if (!customElements.get('rizon-search-tabs')) {
    customElements.define('rizon-search-tabs', RizonSearchTabs);
  }

  class RizonSearchLive extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.input = this.querySelector('.rizon-search-field-large__input');
      this.resultsEl = this.querySelector('[data-search-live-results]');
      this.crumbEl = this.closest('.rizon-search')?.querySelector('.rizon-breadcrumbs__crumb--current');
      this.baseCrumbText = this.crumbEl ? this.crumbEl.textContent : '';
      this.abortController = null;
      this.debounceTimer = null;

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(() => this.update(this.input.value.trim()), 300);
      });

      // Upgrade the server-rendered (classic search) result set to the
      // fuzzier/typo-tolerant predictive-search one on first load too, not
      // just on live typing - the same benefit should apply to a shared or
      // refreshed URL.
      const initialTerm = this.input.value.trim();
      if (initialTerm) this.update(initialTerm, { skipHistory: true });
    }

    async update(term, { skipHistory = false } = {}) {
      if (this.abortController) this.abortController.abort();

      if (!term) {
        this.resultsEl.innerHTML = '';
        if (this.crumbEl) this.crumbEl.textContent = this.baseCrumbText;
        return;
      }

      this.abortController = new AbortController();
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=${this.sectionId}&resources[type]=product,collection,page&resources[limit]=10&resources[limit_scope]=each`;

      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) return;
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newResults = doc.querySelector('[data-search-live-results]');
        if (newResults) this.resultsEl.innerHTML = newResults.innerHTML;

        const newCrumb = doc.querySelector('.rizon-breadcrumbs__crumb--current');
        if (newCrumb && this.crumbEl) this.crumbEl.textContent = newCrumb.textContent;

        if (!skipHistory) {
          const newUrl = `${window.location.pathname}?q=${encodeURIComponent(term)}`;
          window.history.replaceState(window.history.state, '', newUrl);
        }
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    }
  }
  if (!customElements.get('rizon-search-live')) {
    customElements.define('rizon-search-live', RizonSearchLive);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizon-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rizon-faq__item').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    const wrapper = details.querySelector(':scope > .rizon-faq__answer-wrapper');
    if (!summary || !wrapper) return;
    let currentAnimation = null;
    let targetOpen = false;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const opening = !targetOpen;
      targetOpen = opening;
      // While a <details> is natively closed (and not mid-animation),
      // Chrome keeps its content measurable via content-visibility:hidden
      // rather than display:none - so getBoundingClientRect() here would
      // report the answer's full natural height, not the 0 it's actually
      // showing. Only true in that one resting-closed case; mid-animation
      // (either direction) or already-open, the real rendered height is
      // exactly what we want, so measure normally.
      const startHeight =
        opening && !currentAnimation && !details.open ? 0 : wrapper.getBoundingClientRect().height;
      if (opening && !details.open) details.open = true;
      const endHeight = opening ? wrapper.scrollHeight : 0;
      currentAnimation?.cancel();
      wrapper.style.overflow = 'hidden';
      const animation = wrapper.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 250, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' },
      );
      currentAnimation = animation;
      animation.finished
        .then(() => {
          wrapper.style.overflow = '';
          wrapper.style.height = '';
          if (!opening) details.open = false;
          if (currentAnimation === animation) currentAnimation = null;
        })
        .catch(() => {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizon-main-product"] && !Shopify.designMode) return;
  try {
    
  // Adds n business days (Mon-Fri) to date, skipping Saturdays and
  // Sundays entirely - date itself isn't counted, only days stepped
  // forward to. Handles month/year rollover for free since it's built on
  // Date's own setDate arithmetic rather than manual calendar math.
  function addBusinessDays(date, n) {
    const result = new Date(date);
    let added = 0;
    while (added < n) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  // "Www, Mmm D" - e.g. "Wed, Jul 22". getDate() has no leading zero by
  // itself, so this avoids the "07" vs "7" issue a strftime-style %d would
  // have needed a workaround for.
  function formatShippingDate(date) {
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    return `${weekday}, ${month} ${date.getDate()}`;
  }

  class RizonMainProduct extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-copy-link]');
      this.copyButton?.addEventListener('click', this.copyLink.bind(this));

      this.crossSellInputs = Array.from(this.querySelectorAll('[data-cross-sell-variant-id]'));
      if (this.crossSellInputs.length && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, this.addCrossSellItems.bind(this));
      }

      // NB: PUB_SUB_EVENTS is a top-level `const` in constants.js — a global
      // lexical binding, NOT a window property — so guard on the bare name,
      // not window.PUB_SUB_EVENTS (which is always undefined).
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartAdded.bind(this));
      }

      this.initVariantSwitching();
      this.updateShippingEstimate();
      this.initSwatchTooltips();
      this.initStickyBar();
    }

    // Sticky add-to-cart bar: reveal it once the real add-to-cart has scrolled
    // entirely above the viewport (its bottom < 0). The bar's own button
    // submits the real product form via its form= attribute, so no separate
    // add logic is needed here; we only keep its price/availability in sync
    // (applyVariant) and toggle visibility.
    //
    // A rAF-throttled scroll check is used instead of an IntersectionObserver
    // on purpose: IO only fires on intersection *changes*, and the buy box
    // starts below the fold, so a fast flick (or an anchor jump) can carry it
    // straight from below the viewport to above it without ever intersecting -
    // the observer then never fires and the bar silently stays hidden.
    // Reading bottom<0 on scroll is correct in every case (gradual, fast,
    // jump, resize, initial load) and costs one cheap rect read per frame.
    initStickyBar() {
      this.stickyBar = this.querySelector('[data-sticky-atc]');
      if (!this.stickyBar) return;
      this.stickyButton = this.stickyBar.querySelector('.rizon-button-add-to-cart');
      this.stickyPrice = this.stickyBar.querySelector('.rizon-button-add-to-cart__price');

      // Sticky bar's own color swatches are a "remote control" for the main
      // buy box's real radio inputs, not a second source of truth - clicking
      // one checks the matching input inside <variant-selects> and dispatches
      // a real 'change' event so the existing onVariantChange/applyVariant
      // flow (which also keeps these swatches' own active state in sync)
      // handles everything else exactly as if the user clicked the main
      // swatch directly.
      this.stickySwatches = Array.from(this.stickyBar.querySelectorAll('[data-sticky-swatch]'));
      this.stickySwatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          if (swatch.disabled || !this.variantSelects) return;
          const input = this.variantSelects.querySelector(
            `input[data-option-value-id="${swatch.dataset.optionValueId}"]`
          );
          if (!input || input.checked) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      const buyBox = this.querySelector('product-form');
      if (!buyBox) return;

      // Upper bound: the bar must never overlap the "You May Like" carousel,
      // nor reappear once the shopper has scrolled below it. It is a sibling
      // section, hence the document-level lookup.
      const youMayLike = document.querySelector('.rizon-product-carousel--product-page');

      // Allowed to show only while that section's top edge is still below the
      // fold, and it stays negative once scrolled past - so one comparison
      // covers both "don't overlap it" and "don't come back underneath it".
      //
      // The bar's own height is added as a lead so the slide-down STARTS
      // before the section reaches the fold. Without it the bar would still be
      // animating out while the section's first rows were already on screen
      // underneath it, which is exactly the overlap this is meant to prevent.
      //
      // Deliberately derived from the live rect rather than a stored
      // isIntersecting flag: a fast flick or anchor jump can carry the section
      // from below the viewport to above it without ever producing an
      // intersecting frame, leaving such a flag false and the bar wrongly
      // visible below the carousel (the same failure mode described above for
      // the buy box).
      const beforeYouMayLike = () => {
        if (!youMayLike) return true;
        const lead = this.stickyBar.offsetHeight + 24;
        return youMayLike.getBoundingClientRect().top >= window.innerHeight + lead;
      };

      const buyBoxPast = () => buyBox.getBoundingClientRect().bottom < 0;

      let ticking = false;
      const update = () => {
        ticking = false;
        // Show only between the buy box leaving the viewport and the
        // "You May Like" section entering it.
        const show = buyBoxPast() && beforeYouMayLike();
        this.stickyBar.classList.toggle('is-visible', show);
        this.stickyBar.setAttribute('aria-hidden', String(!show));
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      };

      // The observer isn't the source of truth (see above) - it's an extra
      // trigger so the bar re-evaluates the moment the carousel's visibility
      // actually changes, including layout shifts that move the section
      // without any scrolling.
      if (youMayLike && 'IntersectionObserver' in window) {
        // rootMargin extends the root downward by the same lead used above, so
        // the observer fires at the moment the rect rule actually flips rather
        // than one bar-height later.
        const rootLead = Math.round(this.stickyBar.offsetHeight + 24);
        this.youMayLikeObserver = new IntersectionObserver(update, {
          threshold: 0,
          rootMargin: `0px 0px ${rootLead}px 0px`,
        });
        this.youMayLikeObserver.observe(youMayLike);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    // Swatches are right-aligned (rizon-product-variant-picker.liquid), so
    // the last one or two sit close to the viewport edge on mobile - a
    // tooltip centered on those overflows off-screen and gets cropped.
    // Measured right before each tooltip would become visible (its
    // position is unaffected by the opacity/pointer-events hidden state,
    // so this is safe to read even while hidden) and flipped to anchor on
    // the swatch's own edge instead of its center only when it would
    // otherwise overflow.
    initSwatchTooltips() {
      this.querySelectorAll('.rizon-color-swatch').forEach((swatch) => {
        const tooltip = swatch.querySelector('.rizon-color-swatch__tooltip');
        if (!tooltip) return;

        const clampTooltip = () => {
          tooltip.classList.remove(
            'rizon-color-swatch__tooltip--align-start',
            'rizon-color-swatch__tooltip--align-end',
          );
          const margin = 8;
          const rect = tooltip.getBoundingClientRect();
          if (rect.left < margin) {
            tooltip.classList.add('rizon-color-swatch__tooltip--align-start');
          } else if (rect.right > window.innerWidth - margin) {
            tooltip.classList.add('rizon-color-swatch__tooltip--align-end');
          }
        };

        swatch.addEventListener('pointerenter', clampTooltip);
        swatch.addEventListener('focus', clampTooltip);
      });
    }

    // Base is today, unless today is a weekend (delivery companies don't
    // operate then) - in which case it rolls forward to the next Monday.
    // Delivery takes 8 to 12 business days from the base date, so both
    // ends of the range are computed from base directly (not from each
    // other), and neither can land on a weekend since addBusinessDays
    // only ever counts/steps to Mon-Fri.
    updateShippingEstimate() {
      const startEl = this.querySelector('[data-ship-start]');
      const endEl = this.querySelector('[data-ship-end]');
      if (!startEl || !endEl) return;

      const base = new Date();
      base.setHours(0, 0, 0, 0);
      const baseDay = base.getDay();
      if (baseDay === 6) {
        base.setDate(base.getDate() + 2);
      } else if (baseDay === 0) {
        base.setDate(base.getDate() + 1);
      }

      const start = addBusinessDays(base, 8);
      const end = addBusinessDays(base, 12);

      startEl.textContent = formatShippingDate(start);
      endEl.textContent = formatShippingDate(end);
    }

    copyLink() {
      navigator.clipboard?.writeText(window.location.href);
      if (!this.copyButton) return;
      window.clearTimeout(this.copyLinkTimer);
      this.copyButton.classList.add('is-copied');
      this.copyLinkTimer = window.setTimeout(() => {
        this.copyButton.classList.remove('is-copied');
      }, 2500);
    }

    // <variant-selects> (assets/global.js) only tracks selection and
    // publishes a change event - it never touches the page DOM itself. This
    // wires that event up to the pre-formatted variant data emitted by this
    // section's own [data-product-variants] script tag so switching a color
    // actually updates price, availability, the hidden variant id, and the
    // add-to-cart button's price/enabled state.
    initVariantSwitching() {
      const variantsScript = this.querySelector('[data-product-variants]');
      this.variantSelects = this.querySelector('variant-selects');
      if (!variantsScript || !this.variantSelects) return;

      this.variants = JSON.parse(variantsScript.textContent);
      this.variantIdInput = this.querySelector('.product-variant-id');
      this.priceRow = this.querySelector('[data-price-row]');
      this.availabilityStates = Array.from(this.querySelectorAll('[data-availability]'));
      this.addToCartButton = this.querySelector('.rizon-button-add-to-cart');
      this.addToCartPrice = this.querySelector('.rizon-button-add-to-cart__price');

      this.variantSelects.addEventListener('change', this.onVariantChange.bind(this));
    }

    // Dawn's own <variant-selects>.getAllSelectedOptions() only looks inside
    // <fieldset> or .product-form__input--dropdown elements to find each
    // option group - neither matches rizon-product-variant-picker's plain
    // div-based rows (swapped in place of <fieldset>/<legend> since browsers
    // force <legend> to always render as display:block, breaking the
    // label-left/swatches-right layout). Reading selections directly off our
    // own row class avoids depending on that Dawn-internal assumption.
    getSelectedOptions() {
      const selected = [];
      this.variantSelects.querySelectorAll('.rizon-product-options__row').forEach((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) selected.push({ name: checked.dataset.optionName, value: checked.value });
      });
      return selected;
    }

    onVariantChange() {
      if (!this.variants) return;
      const selected = this.getSelectedOptions();
      const variant = this.variants.find((variant) =>
        variant.selectedOptions.every((option) =>
          selected.some((sel) => sel.name === option.name && sel.value === option.value)
        )
      );
      if (variant) this.applyVariant(variant);
    }

    applyVariant(variant) {
      if (this.variantIdInput) this.variantIdInput.value = variant.id;

      if (this.priceRow) {
        this.priceRow.innerHTML = variant.onSale
          ? `<p class="rizon-main-product__price rizon-main-product__price--compare">${variant.compareAtPrice}</p>` +
            `<p class="rizon-main-product__price rizon-main-product__price--sale">${variant.price}</p>` +
            `<span class="rizon-label-sale">${variant.discountPercent}% OFF</span>`
          : `<p class="rizon-main-product__price">${variant.price}</p>`;
      }

      if (this.addToCartPrice) this.addToCartPrice.textContent = variant.price;

      this.availabilityStates.forEach((el) => {
        el.hidden = (el.dataset.availability === 'true') !== variant.available;
      });

      // Not using product-form's own toggleSubmitButton here - it sets
      // submitButtonText.textContent directly, which would flatten the
      // button's nested full/short label spans (the mobile "ADD" text)
      // into one plain text node on every re-enable, permanently losing
      // the responsive split the first time a variant became available
      // again. Availability is already communicated by the separate
      // AVAILABLE row, so the button itself just needs to disable/enable
      // without touching its label.
      if (this.addToCartButton) {
        this.addToCartButton.disabled = !variant.available;
        this.addToCartButton.toggleAttribute('aria-disabled', !variant.available);
      }

      // Keep the sticky bar's button in lockstep with the main one.
      if (this.stickyPrice) this.stickyPrice.textContent = variant.price;
      if (this.stickyButton) {
        this.stickyButton.disabled = !variant.available;
        this.stickyButton.toggleAttribute('aria-disabled', !variant.available);
      }

      // Tell the gallery (a sibling custom element, not a child) which photo
      // to crossfade to. Fired as a document event so neither element has to
      // know how the other is built.
      if (variant.image) {
        document.dispatchEvent(
          new CustomEvent('rizon:variant:image', { detail: variant.image })
        );
      }

      // Keep the sticky bar's own swatches in sync too, regardless of
      // whether the change came from the main buy box or a sticky swatch.
      if (this.stickySwatches && this.stickySwatches.length) {
        const colorOption = variant.selectedOptions.find(
          (option) => option.name === this.stickySwatches[0].dataset.optionName
        );
        if (colorOption) {
          this.stickySwatches.forEach((swatch) => {
            const isActive = swatch.dataset.value === colorOption.value;
            swatch.classList.toggle('is-active', isActive);
            swatch.setAttribute('aria-pressed', String(isActive));
          });
        }
      }
    }

    addCrossSellItems(event) {
      if (event.source !== 'product-form') return;
      const checked = this.crossSellInputs.filter((input) => input.checked);
      if (!checked.length) return;

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: checked.map((input) => ({ id: input.dataset.crossSellVariantId, quantity: 1 })),
        }),
      });
    }

    // Add-to-cart feedback: on a successful add, flash "Added" on both the
    // main and sticky buttons for 1.5s and pop the header cart count.
    onCartAdded(event) {
      if (event.source !== 'product-form') return;
      this.flashAdded(this.addToCartButton);
      this.flashAdded(this.stickyButton);
      this.popCartCount();
    }

    flashAdded(button) {
      if (!button) return;
      const labels = button.querySelectorAll(
        '.rizon-button-add-to-cart__label-full, .rizon-button-add-to-cart__label-short'
      );
      if (!labels.length) return;
      // Set the leaf label spans (not their parent) so the responsive
      // full/short split survives; remember the originals to restore.
      labels.forEach((label) => {
        if (label.dataset.originalText === undefined) label.dataset.originalText = label.textContent;
        label.textContent = 'Added';
      });
      button.classList.add('is-added');
      clearTimeout(button._addedTimer);
      button._addedTimer = setTimeout(() => {
        labels.forEach((label) => {
          if (label.dataset.originalText !== undefined) label.textContent = label.dataset.originalText;
        });
        button.classList.remove('is-added');
      }, 1500);
    }

    popCartCount() {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !window.RizonMotion) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Animate the persistent #cart-icon-bubble <a> (only its inner count is
      // swapped by renderContents, so the element itself survives) — no need
      // to defer, and a rAF here would be throttled in a background tab.
      window.RizonMotion.animate(bubble, { scale: [1, 1.25, 1] }, { duration: 0.45, easing: 'ease-out' });
    }
  }

  if (!customElements.get('rizon-main-product')) {
    customElements.define('rizon-main-product', RizonMainProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizon-search"] && !Shopify.designMode) return;
  try {
    
  class RizonSearchTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-search-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-search-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.searchTab));
      });
    }
    select(name) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.searchTab === name;
        tab.classList.toggle('rizon-tab-search--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.searchPanel !== name;
      });
    }
  }
  if (!customElements.get('rizon-search-tabs')) {
    customElements.define('rizon-search-tabs', RizonSearchTabs);
  }

  class RizonSearchLive extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.input = this.querySelector('.rizon-search-field-large__input');
      this.resultsEl = this.querySelector('[data-search-live-results]');
      this.crumbEl = this.closest('.rizon-search')?.querySelector('.rizon-breadcrumbs__crumb--current');
      this.baseCrumbText = this.crumbEl ? this.crumbEl.textContent : '';
      this.abortController = null;
      this.debounceTimer = null;

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(() => this.update(this.input.value.trim()), 300);
      });

      // Upgrade the server-rendered (classic search) result set to the
      // fuzzier/typo-tolerant predictive-search one on first load too, not
      // just on live typing - the same benefit should apply to a shared or
      // refreshed URL.
      const initialTerm = this.input.value.trim();
      if (initialTerm) this.update(initialTerm, { skipHistory: true });
    }

    async update(term, { skipHistory = false } = {}) {
      if (this.abortController) this.abortController.abort();

      if (!term) {
        this.resultsEl.innerHTML = '';
        if (this.crumbEl) this.crumbEl.textContent = this.baseCrumbText;
        return;
      }

      this.abortController = new AbortController();
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=${this.sectionId}&resources[type]=product,collection,page&resources[limit]=10&resources[limit_scope]=each`;

      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) return;
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newResults = doc.querySelector('[data-search-live-results]');
        if (newResults) this.resultsEl.innerHTML = newResults.innerHTML;

        const newCrumb = doc.querySelector('.rizon-breadcrumbs__crumb--current');
        if (newCrumb && this.crumbEl) this.crumbEl.textContent = newCrumb.textContent;

        if (!skipHistory) {
          const newUrl = `${window.location.pathname}?q=${encodeURIComponent(term)}`;
          window.history.replaceState(window.history.state, '', newUrl);
        }
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    }
  }
  if (!customElements.get('rizon-search-live')) {
    customElements.define('rizon-search-live', RizonSearchLive);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizon-section-icons-benefits"] && !Shopify.designMode) return;
  try {
    
  // Staggered scroll-reveal: the benefit columns fade + slide up in sequence
  // the first time the section enters the viewport. Uses Motion (exposed as
  // window.RizonMotion by rizon-animations.js). Reduced motion — or Motion not
  // being available — leaves the columns in their natural, already-visible
  // state, so nothing is ever hidden without a way to reveal it.
  (function () {
    const section = document.querySelector('.rizon-section-icons-benefits');
    if (!section) return;
    const items = section.querySelectorAll('.rizon-section-icons-benefits__item');
    if (!items.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motion = window.RizonMotion;
    if (reduce || !motion || !motion.inView) return;

    items.forEach((item) => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
    });

    let revealed = false;
    const stop = motion.inView(
      section,
      () => {
        if (revealed) return;
        revealed = true;
        motion.animate(
          items,
          { opacity: [0, 1], y: [20, 0] },
          { duration: 0.8, delay: motion.stagger(0.1), easing: [0.4, 0, 0.2, 1] }
        );
        if (typeof stop === 'function') stop();
      },
      { margin: '0px 0px -100px 0px' }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
